import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useMemo, useState } from 'react';
export default function useIsPressed(forcePressed) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      pressed = _useState2[0],
      setPressed = _useState2[1];

  var eventHandlers = useMemo(function () {
    return {
      onMouseDown: function onMouseDown() {
        setPressed(true);
      },
      onMouseUp: function onMouseUp() {
        setPressed(false);
      },
      onTouchStart: function onTouchStart() {
        setPressed(true);
      },
      onTouchEnd: function onTouchEnd() {
        setPressed(false);
      }
    };
  }, []);
  return [forcePressed !== undefined ? forcePressed : pressed, eventHandlers];
}
//# sourceMappingURL=index.js.map